import { ActionTree, GetterTree, MutationTree } from 'vuex'
// import { IApprovePpState } from './model'
import { IRootState } from '@/store/model'

const states = {
  verifiedTransactionList: [] as any
}

const mutations: MutationTree<any> = {
  PUSH_VERIFIED_TRANSACTION_LIST: (state, data: any) => {
    const item = state.verifiedTransactionList.find((x: any) => x?.FuelingTransactionId === data.FuelingTransactionId)
    if (item) {
      item.Status = data.Status
      item.Note = data.Note
    } else {
      state.verifiedTransactionList.push(data)
    }
  },
  FLUSH_VERIFIED_TRANSACTION_LIST: (state) => {
    state.verifiedTransactionList = []
  }
}

const actions: ActionTree<any, IRootState> = {
  pushVerifiedTransactionList: async ({ commit }, data) => {
    commit('PUSH_VERIFIED_TRANSACTION_LIST', data)
  },
  flushVerifiedTransactionList: async ({ commit }) => {
    commit('FLUSH_VERIFIED_TRANSACTION_LIST')
  }
}

const getters: GetterTree<any, IRootState> = {
  getVerifiedTransactionList(state) {
    return state.verifiedTransactionList
  },
}

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters
}
